// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mp-dashboard-selector{bottom:0;left:0;margin-top:4px;position:absolute;top:32px}mp-dashboard-selector.align-right{left:unset;right:320px}mp-button.save{min-width:92px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
